import sourceEvent from "./sourceEvent";
import point from "./point";

export default function(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = point(node, touches[i]);
  }

  return points;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/touches.js
// module id = FclW
// module chunks = 0